import FeedbackComponents from './components/FeedbackComponents/FeedbackComponents';
import './css/style.css';
import RoutesLinks from './routes/RoutesLinks';

function App() {

  return (
    <>
      <FeedbackComponents />
      <RoutesLinks></RoutesLinks>
    </>
  );
}

export default App;
